import { ReportState } from 'business/quality-control/pages/record-segment-defect/components/left-panel/board-actions/types';

// defectReportState and repairReportState combine as an OR when both are active
// (a defect matching either state is shown), so that e.g. "constat brouillon" +
// "réparation brouillon" surfaces defects in either state rather than only those
// matching both at once. A filter left on `All` is inactive and doesn't
// participate in the OR (otherwise it would always resolve to true and show
// everything, defeating the other active filter).
export const matchesReportStateFilters = ({
  defectReportStateFilter,
  repairReportStateFilter,
  defectSubmittedAt,
  repairSubmittedAt,
}: {
  defectReportStateFilter: ReportState;
  repairReportStateFilter: ReportState;
  defectSubmittedAt: string | null;
  repairSubmittedAt: string | null | undefined;
}): boolean => {
  const isDefectReportStateActive = defectReportStateFilter !== ReportState.All;
  const isRepairReportStateActive = repairReportStateFilter !== ReportState.All;

  // "Validé" specifically means the defect report is submitted AND has no repair
  // report yet — once a repair exists (draft or submitted), the defect belongs to
  // the repair's own lifecycle stage, tracked via repairReportState instead.
  const matchesDefectReportState =
    defectReportStateFilter === ReportState.Draft
      ? defectSubmittedAt === null
      : defectSubmittedAt !== null && repairSubmittedAt === undefined;

  const matchesRepairReportState =
    repairReportStateFilter === ReportState.Draft
      ? repairSubmittedAt === null
      : repairSubmittedAt !== null && repairSubmittedAt !== undefined;

  if (!isDefectReportStateActive && !isRepairReportStateActive) {
    return true;
  }
  if (isDefectReportStateActive && isRepairReportStateActive) {
    return matchesDefectReportState || matchesRepairReportState;
  }
  return isDefectReportStateActive
    ? matchesDefectReportState
    : matchesRepairReportState;
};
